import React, { useState } from 'react';
import { ScrollText, Slider } from '..';
import { Container, Title } from '../styled/styled';

import mobileApps from '../../image/mobile-apps.svg';
import project from '../../image/project.svg';
import websites from '../../image/websites.svg';

import tiger from '../../image/slider/1.png';
import dapp from '../../image/slider/2.png';
import zaznallsya from '../../image/slider/3.png';

import ellipse from '../../image/Ellipse.svg';
import styled from 'styled-components';

const portfolioMok = [
  {
    id: 1,
    image: mobileApps,
    active: true,
    name: 'Mobile apps',
  },
  {
    id: 2,
    image: project,
    name: 'Crypto projects',
  },
  {
    id: 3,
    image: websites,
    name: 'Websites',
  },
];
const imageMok = [
  {
    id: 1,
    image: tiger,
  },
  {
    id: 2,
    image: dapp,
  },
  {
    id: 4,
    image: zaznallsya,
  },
];
const imageMok2 = [
  {
    id: 1,
    image: dapp,
  },
  {
    id: 2,
    image: dapp,
  },
  {
    id: 4,
    image: dapp,
  },
];
const imageMok3 = [
  {
    id: 1,
    image: zaznallsya,
  },
  {
    id: 2,
    image: zaznallsya,
  },
  {
    id: 4,
    image: zaznallsya,
  },
];
const swiperMok = [
  {
    id: 1,
    swiper: <Slider imageMok={imageMok} />,
    name: mobileApps,
    active: true,
  },
  {
    id: 2,
    swiper: <Slider imageMok={imageMok2} />,
    name: project,
  },
  {
    id: 3,
    swiper: <Slider imageMok={imageMok3} />,
    name: websites,
  },
];

const PortfolioStyled = styled.div`
  &::after {
    content: '';
    position: absolute;
    right: -50px;
    bottom: -200px;
    background: url(${ellipse}) no-repeat center;
    width: 565px;
    height: 100%;
    z-index: -1;
  }
  @media (max-width: 1500px) {
    &::after {
      bottom: -100px;
    }
  }
  @media (max-width: 992px) {
    margin: 80px auto;
    &::after {
      display: none;
    }
  }
  @media (max-width: 420px) {
    margin: 120px auto;
    &::after {
      display: none;
    }
  }
  @media (max-height: 460px) {
    margin: 0px auto;
  }
  @media (max-height: 660px) {
    margin: 40px auto;
  }
`;

const PortfolioList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 100px;
  max-width: 1150px;
  width: 100%;

  @media (max-width: 840px) {
    margin-top: 50px;
  }
  @media (max-width: 620px) {
    flex-direction: column;
    margin-top: 40px;
  }
  @media (max-height: 560px){
    margin-top: 10px;
    flex-direction row;
  }
`;

const PortfolioButton = styled.button`
  border: none;
  margin: 0;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  cursor: pointer;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-left: 30px;

  img {
    margin-top: 0px !important;
    position: absolute;
    left: -15px;
    margin-right: 10px;
    max-width: 35px;
    width: 100%;
  }
  p {
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
    text-align: justify;
    color: #000000;
  }
  @media (max-width: 992px) {
    p {
      font-size: 30px;
      line-height: 38px;
    }
    img {
      left: -10px;
      max-width: 25px;
      width: 100%;
    }
  }
  @media (max-width: 720px) {
    p {
      font-size: 20px;
      line-height: 28px;
    }
  }
  @media (max-width: 620px) {
    margin-top: 20px;
    font-size: 20px;
    line-height: 24px;
  }
  @media (max-height: 460px) {
    margin-top: 20px;
    font-size: 18px;
  }
  &.profile__active {
    p {
      font-weight: bold;
    }
    background: linear-gradient(
      180deg,
      rgba(209, 160, 86, 0.068) 0%,
      rgba(171, 25, 222, 0.216) 100%
    );
  }
  &.profile__active:nth-child(2) {
    background: linear-gradient(180deg, rgba(62, 236, 248, 0.16) 0%, rgba(207, 210, 27, 0.24) 100%);
  }
  &.profile__active:nth-child(3) {
    background: linear-gradient(
      180deg,
      rgba(171, 25, 222, 0.204) 0%,
      rgba(62, 236, 248, 0.16) 100%
    );
  }
`;

export const Portfolio = () => {
  const [activeButton, setActiveButton] = useState();
  const [activeSwiper, setActiveSwiper] = useState(false);

  const handleActive = (image: any) => {
    setActiveButton(image);
    setActiveSwiper(true);
  };

  return (
    <PortfolioStyled id="portfolio">
      <div>
        <Container>
          <Title>OUR PORTFOLIO</Title>
        </Container>
        {swiperMok.map((item) => (
          <div key={item.id}>
            {!activeSwiper && item.active === true
              ? item.name && item.swiper
              : activeButton === item.name && item.swiper}
          </div>
        ))}
        <Container>
          <PortfolioList>
            {portfolioMok.map((item) => (
              <PortfolioButton
                className={
                  !activeSwiper && item.active === true
                    ? 'profile__active'
                    : item.image === activeButton
                    ? 'profile__active'
                    : ''
                }
                onClick={() => handleActive(item.image)}
                key={item.id}>
                <img alt="" src={item.image} />
                <p>{item.name}</p>
              </PortfolioButton>
            ))}
          </PortfolioList>
          <ScrollText>SCROLL DOWN TO WATCH OUR CONTACT</ScrollText>
        </Container>
      </div>
    </PortfolioStyled>
  );
};
